export type Format = "showcase" | "domestic" | "industrial" | "other";
export type Typology =
  | "artist_run"
  | "exhibition"
  | "curatorial"
  | "studio"
  | "collective"
  | "residency"
  | "editorial"
  | "digital_platform"
  | "nomad"
  | "festival"
  | "workshop";
export type Practice =
  | "plastic_arts"
  | "music_sound"
  | "theater_performance"
  | "cinema_video"
  | "architecture"
  | "photo"
  | "ict" //illustration_ceramics_textile
  | "edition_printing"
  | "literature";

export type Inauguration = 1980 | 1990 | 2000 | 2010 | 2020;

export type Schedule = {
  monday?: string[];
  tuesday?: string[];
  wednesday?: string[];
  thursday?: string[];
  friday?: string[];
  saturday?: string[];
  sunday?: string[];
};

export function shouldHideSchedule(space: SpaceModel | undefined) {
  const schedule = space?.weekSchedule
  const res = (
    (!space?.properties.open ||
      !schedule ||
      !Object.values(schedule).find((day) => {
        return day && day.length > 0;
      })) &&
    (!space?.scheduleByAppointment && !space?.scheduleByEventCalendar)
  );
  console.log(`res: ${res}`)
  return res;
}

export function hasContacts(space: SpaceModel) {
  return space && (space.properties.website || space.properties.phone ||
    space.properties.instagram || space.properties.email ||
    space.properties.facebook)
}

export function hasTech(space: SpaceModel) {
  return space && ((space.properties.agents && space.properties.agents.join().trim().length > 0) ||
    ((space.agentRoles) && space.agentRoles.length > 0))
}

export type AgentRole = {
  role: string;
  agents: string[];
};

export type Address = {
  partOne: string,
  partTwo: string,
  zipCode: string,
  city: string
}

export type Image = { id: string; url: string; label: string, height: number, width: number };

export interface SpaceProperties {
  inauguration: number;
  opening?: number;
  closing?: number;
  typology: string[];
  format: string[];
  practice: string[];
  name: string;
  website?: string;
  schedule?: string;
  instagram?: string;
  facebook?: string;
  email?: string;
  phone?: string;
  agents?: string[];
  address?: string;
  open: boolean;
}

export interface SpaceModel {
  id?: string;
  coordinates: number[];
  properties: SpaceProperties;
  weekSchedule?: Schedule;
  pastAgents?: string[];
  agentRoles?: AgentRole[];
  pastAddresses?: string[];
  bio?: string;
  imageUrls?: Image[];
  mainAddress?: Address;
  oldAddresses?: Address[];
  scheduleByAppointment?: boolean,
  scheduleByEventCalendar?: boolean
}
